import Cookies from 'js-cookie';
import { PREFERRED_LOCALE_COOKIE_NAME } from '@raisin/cp-utils';

export const handleLocaleChange = (
  event: React.MouseEvent<HTMLAnchorElement>,
  preferredLocale: string,
) => {
  event.preventDefault();

  Cookies.set(PREFERRED_LOCALE_COOKIE_NAME, preferredLocale);

  window.location.href = event.currentTarget.href;
};
